"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityType = void 0;
var EntityType;
(function (EntityType) {
    EntityType["all"] = "allEntities";
    EntityType["provider"] = "provider";
    EntityType["user"] = "user";
    EntityType["patient"] = "patient";
    EntityType["site"] = "site";
})(EntityType = exports.EntityType || (exports.EntityType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/shared/connect-asset.ts
// module id = 529
// module chunks = 0 1 2